import YouTubeClaimsIndex from '../components/YouTube/Claims/Search/Index'
import YouTubeClaimsRequestIndex from '../components/YouTube/Claims/Request/Index'
import YouTubeClaimsRequestForm from '../components/YouTube/Claims/Request/Form'
import YouTubeAssetsIndex from '../components/YouTube/Assets/Index'
import YouTubeClaimsReportIndex from '../components/YouTube/Claims/Reports/Index'

export default [
  {
    path: '/client/youtube/claims/search',
    name: 'youtube-claims-search-index',
    component: YouTubeClaimsIndex,
    meta: {
      sideMenuId: 'youtube-claims-search-index',
    },
  },
  {
    path: '/client/youtube/claims/request',
    name: 'youtube-claims-request-index',
    component: YouTubeClaimsRequestIndex,
    meta: {
      sideMenuId: 'youtube-claims-request-index',
    },
  },
  {
    path: '/client/youtube/claims/request/form/:videoId',
    name: 'youtube-claims-request-form',
    props: true,
    component: YouTubeClaimsRequestForm,
    meta: {
      sideMenuId: 'youtube-claims-request-form',
    },
  },
  {
    path: '/client/youtube/claims/assets',
    name: 'youtube-claims-assets-index',
    component: YouTubeAssetsIndex,
    meta: {
      sideMenuId: 'youtube-claims-assets-index',
    },
  },
  {
    path: '/client/youtube/claims/reports',
    name: 'youtube-claims-report-index',
    component: YouTubeClaimsReportIndex,
    meta: {
      sideMenuId: 'youtube-claims-report-index',
    },
  },
]
